var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 171,
    viewBox: "0 0 164 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 163.5,
    height: 163.5,
    rx: 81.75,
    stroke: "#F7F7F8",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 16.25,
    width: 131.5,
    height: 131.5,
    rx: 65.75,
    stroke: "#F2F2F3",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.25,
    y: 32.25,
    width: 99.5,
    height: 99.5,
    rx: 49.75,
    stroke: "#F2F2F3",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_148_1943)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 68,
    height: 68,
    rx: 34,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.25,
    y: 48.25,
    width: 67.5,
    height: 67.5,
    rx: 33.75,
    stroke: "#ECEDEE",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_148_1943)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 64.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.5 79H85.5V77C85.5 76.7348 85.3946 76.4804 85.2071 76.2929C85.0196 76.1054 84.7652 76 84.5 76H76.5C76.2348 76 75.9804 76.1054 75.7929 76.2929C75.6054 76.4804 75.5 76.7348 75.5 77V85C75.5003 85.0941 75.5271 85.1861 75.5774 85.2657C75.6277 85.3452 75.6993 85.4089 75.7842 85.4495C75.8691 85.4901 75.9636 85.5059 76.0571 85.4952C76.1505 85.4844 76.2391 85.4475 76.3125 85.3888L78.5 83.625V85.5C78.5 85.7652 78.6054 86.0196 78.7929 86.2071C78.9804 86.3946 79.2348 86.5 79.5 86.5H85.3494L87.6875 88.3888C87.776 88.4603 87.8862 88.4996 88 88.5C88.1326 88.5 88.2598 88.4473 88.3536 88.3536C88.4473 88.2598 88.5 88.1326 88.5 88V80C88.5 79.7348 88.3946 79.4804 88.2071 79.2929C88.0196 79.1054 87.7652 79 87.5 79ZM78.1594 82.6112L76.5 83.9531V77H84.5V82.5H78.4738C78.3593 82.5 78.2483 82.5393 78.1594 82.6112ZM87.5 86.9531L85.8406 85.6112C85.7522 85.5397 85.6419 85.5004 85.5281 85.5H79.5V83.5H84.5C84.7652 83.5 85.0196 83.3946 85.2071 83.2071C85.3946 83.0196 85.5 82.7652 85.5 82.5V80H87.5V86.9531Z",
    fill: "#070808"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_148_1943",
    x: 15,
    y: 23,
    width: 148,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_148_1943"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_148_1943",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_148_1943",
    x: 49,
    y: 56,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_148_1943"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.886061 0 0 0 0 0.873939 0 0 0 0 0.966061 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_148_1943"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_148_1943",
    result: "effect2_dropShadow_148_1943"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_148_1943",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessage);
export default __webpack_public_path__ + "static/media/noMessage.de093f95.svg";
export { ForwardRef as ReactComponent };